function setupAccordionToggles() {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const currentItem = toggle.closest('.accordion-item');

      // Close all other items
      document.querySelectorAll('.accordion-item').forEach((item) => {
        if (item !== currentItem) {
          item.querySelector('.accordion-content')?.classList.remove('open');
          item.querySelector('.accordion-toggle')?.classList.remove('active');
        }
      });

      // Toggle current item
      const content = toggle.nextElementSibling;
      if (content && content.classList.contains('accordion-content')) {
        const isNowOpen = content.classList.toggle('open');
        toggle.classList.toggle('active', isNowOpen);
      }
    });
  });

  // ✅ Open first item automatically
  const firstItem = document.querySelector('.accordion-item');
  if (firstItem) {
    const firstContent = firstItem.querySelector('.accordion-content');
    const firstToggle = firstItem.querySelector('.accordion-toggle');
    firstContent?.classList.add('open');
    firstToggle?.classList.add('active');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    if (document.querySelector('.accordion-toggle')) {
      clearInterval(interval);
      setupAccordionToggles();
    }
  }, 100);
});
